export default __webpack_public_path__ + "static/media/T6.944a626e.jpg";